// extracted by mini-css-extract-plugin
module.exports = {"sidebar-icons":"SocialIcons_sidebar-icons__1dQSU","demo-icon":"SocialIcons_demo-icon__2Tl92"};